// api/admin/rate.ts
import { API_BASE, getAuthHeaders } from "./config";

export type Period = 'all' | 'week';

export type TopRatedItem = {
    content_id: number;
    title: string;
    avg_rating: number;
    ratings_count: number;
};

export async function fetchTopRated(period: Period): Promise<TopRatedItem[]> {
    const res = await fetch(`${API_BASE}/ratings/top?period=${encodeURIComponent(period)}`, {
        headers: getAuthHeaders(),
    });
    if (!res.ok) throw await res.json();
    return res.json();
}

export type RatedContent = {
    id: number;
    title: string;
    type: 'TEXT' | 'AUDIO' | 'BOTH' | string;
    language?: string | null;
    is_visible: boolean;
    is_premium: boolean;
    created_at: string;

    category_title?: string | null;
    avg_rating?: number | null;
    ratings_count?: number | null;
};

export async function fetchAllRatedContents(): Promise<RatedContent[]> {
    // backend: GET /contents/details (z avg_rating, ratings_count)
    const res = await fetch(`${API_BASE}/contents/details`, { headers: getAuthHeaders() });
    if (!res.ok) throw await res.json();
    const data = await res.json();
    // tylko treści z co najmniej 1 oceną
    return (data as RatedContent[]).filter(
        (it) => (it.ratings_count ?? 0) > 0
    );
}
